import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { IconsModule } from './icons.module';
import { PrimengModule } from './primeng.module';
import { DropdownModule } from 'primeng/dropdown';
import { NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { CookieService } from 'ngx-cookie-service';

import { HeaderComponent } from './header/header.component';
import { TotalCountCardComponent } from './total-count-card/total-count-card.component';
import { StatusCardComponent } from './status-card/status-card.component';
import { QuickActionComponent } from './quick-action/quick-action.component';
import { WizardComponent } from './quick-action/wizard/wizard.component';
import { AnnualOutcomeComponent } from './annual-outcome/annual-outcome.component';
import { BacklogComponent } from './backlog/backlog.component';
import { QuarterlyOutcomeComponent } from './quarterly-outcome/quarterly-outcome.component';
import { MilestoneComponent } from './milestone/milestone.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { PolarComponent } from './charts/polar/polar.component';
import { BarComponent } from './charts/bar/bar.component';
import { DoughnutComponent } from './charts/doughnut/doughnut.component';
import { PieComponent } from './charts/pie/pie.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { LoaderComponent } from './loader/loader.component';
import { MilestoneStatusCountComponent } from "./quarterly-outcome/milestone-status-count/milestone-status-count.component";
import { PaginatorModule } from 'primeng/paginator';
import { VirtualScrollComponent } from './virtual-scroll/virtual-scroll.component';
import { ShimmerListComponent } from './shimmer/shimmer-list/shimmer-list.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { IsMemberPipe } from '../work-package/pipes/is-member.pipe';
import { ShimmerDashboardCountComponent } from './shimmer/shimmer-dashboard-count/shimmer-dashboard-count.component';
import { KanbanShimmerComponent } from './shimmer/kanban-shimmer/kanban-shimmer.component';
import { IsPlanningPhasePipe } from '../work-package/pipes/is-planning-phase.pipe';
import { FilterByPlacePipe } from "../work-package/pipes/filter-by-place.pipe";
import { CanViewActionItemPipe } from '../work-package/pipes/can-view-action-item.pipe';
import { SvgImageComponent } from './svg-image/svg-image.component';
import { DateFormatPipe } from './pipes/dateFormat.pipe';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { TruncatePipe } from '../work-package/pipes/truncate.pipe';
import { IsBacklogExistPipe } from '../work-package/pipes/is-backlog-exist.pipe';


@NgModule({
  declarations: [
    HeaderComponent,
    TotalCountCardComponent,
    StatusCardComponent,
    QuickActionComponent,
    WizardComponent,
    AnnualOutcomeComponent,
    BacklogComponent,
    QuarterlyOutcomeComponent,
    MilestoneComponent,
    PolarComponent,
    BarComponent,
    DoughnutComponent,
    PieComponent,
    SidebarComponent,
    DropdownComponent,
    LoaderComponent,
    MilestoneStatusCountComponent,
    VirtualScrollComponent,
    ShimmerListComponent,
    PageNotFoundComponent,
    ShimmerDashboardCountComponent,
    KanbanShimmerComponent,
    IsPlanningPhasePipe,
    CanViewActionItemPipe,
    SvgImageComponent,
    BreadcrumbComponent,
    TruncatePipe,
    IsBacklogExistPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    IconsModule,
    PrimengModule,
    DropdownModule,
    NgbTooltipModule,
    NgbPopoverModule,
    NgApexchartsModule,
    ReactiveFormsModule,
    PaginatorModule,
    IsMemberPipe,
    FilterByPlacePipe,
    DateFormatPipe,

],
  exports: [
    CommonModule,
    FormsModule,
    IconsModule,
    PrimengModule,
    NgApexchartsModule,
    NgbTooltipModule,
    NgbPopoverModule,
    HeaderComponent,
    TotalCountCardComponent,
    StatusCardComponent,
    QuickActionComponent,
    AnnualOutcomeComponent,
    BacklogComponent,
    QuarterlyOutcomeComponent,
    MilestoneComponent,
    BarComponent,
    PolarComponent,
    DoughnutComponent,
    SidebarComponent,
    DropdownComponent,
    LoaderComponent,
    VirtualScrollComponent,
    ShimmerListComponent,
    PageNotFoundComponent,
    ShimmerDashboardCountComponent,
    KanbanShimmerComponent,
    DateFormatPipe,
    BreadcrumbComponent,
    TruncatePipe,
    IsBacklogExistPipe
  ],
  providers: [CookieService, DatePipe],
})
export class SharedModule {}
